const getLockupRows = (offerData) => {
    const rows = offerData?.publicoAlvoDatasLockup?.rows ?? []

    return rows.map((row) => {
        const origem = row.label

        return {
            label: row.label,
            values: [
                {
                    label: `Data lockup ${origem} para IG`,
                    value: row.values?.ig,
                },
                {
                    label: `Data lockup ${origem} para IP`,
                    value: row.values?.ip,
                },
                {
                    label: `Data lockup ${origem} para IQ`,
                    value: row.values?.iq,
                },
            ],
        }
    })
}

const getOfertaModalSections = (offerData, characterData) => [
    {
        fields: [
            {
                label: "TIPO",
                value: characterData?.tipo_oferta ?? "Não Tem",
            },
        ],
    },
    {
        type: "split",
        gridTemplateColumns: {
            xxxs: "1fr",
            xs: "1fr",
            sm: "1fr",
            md: "1fr",
            lg: "minmax(0, 9fr) minmax(0, 3fr)",
        },
        columns: [
            {
                title: "SRE CVM",
                md: 9,
                fields: [
                    {
                        label: "Tipo rito",
                        value: offerData?.sreCvm?.tipoRito,
                        xs: 4,
                        sm: 4,
                        md: 2,
                    },
                    {
                        label: "Data requerimento",
                        value: offerData?.sreCvm?.dataRequerimento,
                        xs: 4,
                        sm: 4,
                        md: 2,
                    },
                    {
                        label: "Distribuição link SRE",
                        value: offerData?.sreCvm?.distribuicaoLinkSre,
                        href: offerData?.sreCvm?.distribuicaoLinkSreHref,
                        xs: 4,
                        sm: 4,
                        md: 3,
                    },
                    {
                        label: "Tipo mercado",
                        value: offerData?.sreCvm?.tipoMercado,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Regime distribuição",
                        value: offerData?.sreCvm?.regimeDistribuicao,
                        xs: 6,
                        sm: 6,
                        md: 3,
                    },
                ],
            },
            {
                title: "Data Reserva",
                md: 3,
                fields: [
                    {
                        label: "Início",
                        value: offerData?.dataReserva?.inicio,
                        xs: 6,
                        sm: 6,
                        md: 6,
                    },
                    {
                        label: "Encerramento",
                        value: offerData?.dataReserva?.encerramento,
                        xs: 6,
                        sm: 6,
                        md: 6,
                    },
                ],
            },
        ],
    },

    {
        type: "split",
        mb: 1,
        columns: [
            {
                title: "Data Oferta",
                md: 12,
                fields: [
                    {
                        label: "Início",
                        value: offerData?.dataOferta?.inicio,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Encerramento máximo",
                        value: offerData?.dataOferta?.encerramentoMaximo,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Encerramento efetivo",
                        value: offerData?.dataOferta?.encerramentoEfetivo,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                ],
            },
        ],
    },

    {
        type: "split",
        mb: 2,
        columns: [
            {
                title: "Bookbuilding",
                md: 12,
                fields: [
                    {
                        label: "Tem",
                        value: offerData?.bookbuilding?.tem,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Data",
                        value: offerData?.bookbuilding?.data,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Remuneração",
                        value: offerData?.bookbuilding?.remuneracao,
                        xs: 6,
                        sm: 6,
                        md: 3,
                    },
                ],
            },
        ],
    },

    {
        type: "matrix",
        title: "Publico Alvo e Datas Lockup",
        mb: 0.5,
        columns:
            offerData?.publicoAlvoDatasLockup?.columns ?? [
                "IG",
                "IP",
                "IQ",
            ],
        rows: getLockupRows(offerData),
        sideGroups: [
            {
                title: "Publico alvo investidor geral",
                fields: [
                    {
                        label: "Inicial",
                        value:
                            offerData?.publicoAlvoInvestidorGeral?.inicial,
                    },
                    {
                        label: "Final",
                        value:
                            offerData?.publicoAlvoInvestidorGeral?.final,
                    },
                ],
            },
            {
                title: "Publico alvo investidor qualificado",
                fields: [
                    {
                        label: "Inicial",
                        value:
                            offerData
                                ?.publicoAlvoInvestidorQualificado?.inicial,
                    },
                    {
                        label: "Final",
                        value:
                            offerData
                                ?.publicoAlvoInvestidorQualificado?.final,
                    },
                ],
            },
            {
                title: "Publico alvo investidor profissional",
                fields: [
                    {
                        label: "Inicial",
                        value:
                            offerData
                                ?.publicoAlvoInvestidorProfissional?.inicial,
                    },
                    {
                        label: "Final",
                        value:
                            offerData
                                ?.publicoAlvoInvestidorProfissional?.final,
                    },
                ],
            },
        ],
    },

    {
        type: "cards",
        title: "Coordenadores",
        titleSx: {
            mb: 0.5,
        },
        cards: offerData?.coordenadores ?? [],
    },
]
const getGarantiasModalSections = (garantiasData) => [
    {
        title: "Garantias Reais",
        fields: [
            {
                label: `ALIENAÇÃO FIDUCIÁRIA: ${
                    garantiasData?.garantias_reais?.valor_alienacao_fiduciaria ?? ""
                }`,
                value:
                    garantiasData?.garantias_reais?.alienacao_fiduciaria ??
                    "Não Tem",
            },
            {
                label: `CESSÃO FIDUCIÁRIA: ${
                    garantiasData?.garantias_reais?.valor_cessao_fiduciaria ?? ""
                }`,
                value:
                    garantiasData?.garantias_reais?.cessao_fiduciaria ??
                    "Não Tem",
            },
            {
                label: "FIANÇA BANCÁRIA",
                value:
                    garantiasData?.garantias_reais?.fianca_bancaria ??
                    "Não Tem",
            },
            {
                label: `HIPOTECA: ${
                    garantiasData?.garantias_reais?.valor_hipoteca ?? ""
                }`,
                value:
                    garantiasData?.garantias_reais?.hipoteca ??
                    "Não Tem",
            },
            {
                label: `PENHOR: ${
                    garantiasData?.garantias_reais?.valor_penhor ?? ""
                }`,
                value:
                    garantiasData?.garantias_reais?.penhor ??
                    "Não Tem",
            },
        ],
    },

    {
        title: "Garantias Fidejussórias",
        fields: [
            {
                label: `AVAL: ${
                    garantiasData?.garantias_fidejussorias?.valor_aval ?? ""
                }`,
                value:
                    garantiasData?.garantias_fidejussorias?.aval ??
                    "Não Tem",
            },
            {
                label: `FIANÇA: ${
                    garantiasData?.garantias_fidejussorias?.valor_fianca ?? ""
                }`,
                value:
                    garantiasData?.garantias_fidejussorias?.fianca ??
                    "Não Tem",
            },
        ],
    },

    {
        title: "Mitigador de risco de crédito",
        fields: [
            {
                label: `FUNDO OBRA: ${
                    garantiasData?.mitigadores?.valor_fundo_obra ?? ""
                }`,
                value:
                    garantiasData?.mitigadores?.fundo_obra ??
                    "Não Tem",
            },
            {
                label: `FUNDO RESERVA: ${
                    garantiasData?.mitigadores?.valor_fundo_reserva ?? ""
                }`,
                value:
                    garantiasData?.mitigadores?.fundo_reserva ??
                    "Não Tem",
            },
            {
                label: `FUNDO LIQUIDEZ: ${
                    garantiasData?.mitigadores?.valor_fundo_liquidez ?? ""
                }`,
                value:
                    garantiasData?.mitigadores?.fundo_liquidez ??
                    "Não Tem",
            },
            {
                label: `SOBREGARANTIA: ${
                    garantiasData?.mitigadores?.valor_sobregarantia ?? ""
                }`,
                value:
                    garantiasData?.mitigadores?.sobregarantia ??
                    "Não Tem",
            },
            {
                label: `SEGURO: ${
                    garantiasData?.mitigadores?.valor_seguro ?? ""
                }`,
                value:
                    garantiasData?.mitigadores?.seguro ??
                    "Não Tem",
            },
            {
                label: `COTAS INFERIORES: ${
                    garantiasData?.mitigadores?.valor_cotas_inferiores ?? ""
                }`,
                value:
                    garantiasData?.mitigadores?.cotas_inferiores ??
                    "Não Tem",
            },
        ],
    },

    {
        title: "LTV",
        fields: [
            {
                label: "DATA REFERÊNCIA",
                value:
                    garantiasData?.ltv?.data_referencia ??
                    "Não Tem",
            },
            {
                label: "VALOR",
                value:
                    garantiasData?.ltv?.ltv ??
                    "Não Tem",
            },
            {
                label: "CETIP",
                value:
                    garantiasData?.ltv?.cetip ??
                    "Não Tem",
            },
        ],
    },
]

export const getEmissionDetailsModalConfig = ({
    characterData,
    garantiasData,
    offerData,
}) => ({
    guarantees: {
        title: "Garantias",
        sections: getGarantiasModalSections(garantiasData),
    },

    offer_type: {
        title: "Oferta Pública de Distribuição",
        sections: getOfertaModalSections(
            offerData,
            characterData
        ),
    },

    relevant_fact: {
        title: "Fato Relevante",
        sections: [
            {
                fields: [
                    {
                        label: "DATA REFERÊNCIA",
                        value:
                            characterData?.data_referencia_fato_relevante ??
                            "Não Tem",
                    },
                    {
                        label: "FATO",
                        value:
                            characterData?.fato_relevante ??
                            "Não Tem",
                    },
                ],
            },
        ],
    },
})